import CategoryRoundedIcon from '@mui/icons-material/CategoryRounded';
import DisplaySettingsRoundedIcon from '@mui/icons-material/DisplaySettingsRounded';
import KeyRoundedIcon from '@mui/icons-material/KeyRounded';
import DriverRoundedIcon from 'app/icons/DriverRoundedIcon';
import TrailerRoundedIcon from 'app/icons/TrailerRoundedIcon';
import TransportGroupRoundedIcon from 'app/icons/TransportGroupRoundedIcon';
import TransportRoundedIcon from 'app/icons/TransportRoundedIcon';
import AuthenticationLayout from 'app/layouts/AuthenticationLayout';
import ContentLayout from 'app/layouts/ContentLayout';
import Checklist from 'app/pages/Checklist';
import Driver from 'app/pages/Driver';
import Forgot from 'app/pages/Forgot';
import GeofenceGroup from 'app/pages/GeofenceGroup';
import Issue from 'app/pages/Issue';
import Login from 'app/pages/Login';
import Map from 'app/pages/Map';
import NotFound from 'app/pages/NotFound';
import Settings from 'app/pages/Settings';
import Token from 'app/pages/Token';
import Trailer from 'app/pages/Trailer';
import Transport from 'app/pages/Transport';
import TransportGroup from 'app/pages/TransportGroup';
import TwoFactory from 'app/pages/TwoFactory';
import User from 'app/pages/User';

export default [
    {
        path: '/',
        exact: true,
        auth: 'optional',
        title: 'Добро пожаловать',
        layout: AuthenticationLayout,
        component: Login,
        permissions: ['read'],
    },
    {
        path: '/account/setup-2fa',
        auth: 'optional',
        exact: true,
        title: 'Двухфакторная авторизация',
        layout: AuthenticationLayout,
        component: TwoFactory,
        permissions: ['read'],
    },
    {
        path: '/account/check-2fa',
        auth: 'optional',
        exact: true,
        title: 'Двухфакторная авторизация',
        layout: AuthenticationLayout,
        component: TwoFactory,
        permissions: ['read'],
    },
    {
        path: '/account/forgot',
        auth: 'optional',
        title: 'Восстановить доступ',
        layout: AuthenticationLayout,
        component: Forgot,
        permissions: ['read'],
    },
    {
        path: '/map',
        auth: 'required',
        title: 'Карта',
        layout: ContentLayout,
        component: Map,
        permissions: ['read', 'activity'],
    },
    {
        path: '/user',
        auth: 'required',
        title: 'Пользователи',
        layout: ContentLayout,
        component: User,
        permissions: ['create', 'update', 'delete', 'checklist_update'],
    },
    {
        path: '/transport',
        auth: 'required',
        icon: TransportRoundedIcon,
        title: 'Транспорт',
        layout: ContentLayout,
        component: Transport,
        permissions: ['create', 'update', 'delete', 'read+'],
    },
    {
        path: '/trailer',
        auth: 'required',
        icon: TrailerRoundedIcon,
        title: 'Прицепы',
        layout: ContentLayout,
        component: Trailer,
        permissions: ['create', 'update', 'delete'],
    },
    {
        path: '/driver',
        auth: 'required',
        icon: DriverRoundedIcon,
        title: 'Водители',
        layout: ContentLayout,
        component: Driver,
        permissions: ['create', 'update', 'delete'],
    },
    {
        path: '/issue',
        auth: 'required',
        icon: DriverRoundedIcon,
        title: 'Заявки',
        layout: ContentLayout,
        component: Issue,
        permissions: ['read', 'activity'],
    },
    {
        path: '/transport-group',
        auth: 'required',
        icon: TransportGroupRoundedIcon,
        title: 'Группы транспорта',
        layout: ContentLayout,
        component: TransportGroup,
        permissions: ['create', 'update', 'delete'],
    },
    {
        path: '/geofence-group',
        auth: 'required',
        icon: CategoryRoundedIcon,
        title: 'Группы геозон',
        layout: ContentLayout,
        component: GeofenceGroup,
        permissions: ['create', 'update', 'delete'],
    },
    {
        path: '/token',
        auth: 'required',
        icon: KeyRoundedIcon,
        title: 'Токены',
        layout: ContentLayout,
        component: Token,
        permissions: ['create', 'update', 'delete'],
    },
    {
        path: '/checklist',
        auth: 'required',
        title: 'Чеклисты',
        layout: ContentLayout,
        component: Checklist,
        permissions: ['checklist_read', 'checklist_create', 'checklist_update', 'checklist_delete'],
    },
    {
        path: '/settings',
        auth: 'required',
        icon: DisplaySettingsRoundedIcon,
        title: 'Настройки приложения',
        layout: ContentLayout,
        component: Settings,
        permissions: ['create'],
    },
    {
        path: '*',
        title: 'Страница не найдена',
        component: NotFound,
    },
];
